const FIND_ELEMENT_ASYNC_INTERVAL = 50;
const FIND_ELEMENT_ASYNC_TIMEOUT = 400;

export async function findElementAsync(
  selector: string,
  parentNode: HTMLElement | Document = document
): Promise<HTMLElement | null> {
  const start = Date.now();

  return new Promise((resolve) => {
    const tryFind = (): void => {
      const el = parentNode.querySelector<HTMLElement>(selector);
      if (el) {
        resolve(el);
      } else if (Date.now() - start >= FIND_ELEMENT_ASYNC_INTERVAL) {
        resolve(null);
      } else {
        setTimeout(tryFind, FIND_ELEMENT_ASYNC_TIMEOUT);
      }
    };
    tryFind();
  });
}
